module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAAXNSR0IArs4c6QAAARBJREFUOE+tlCFzwmAQRB8zFRUIREVFRQWiAsH/VxUIZEVFRQUCgUBUIBCIzpv5jvkISTgSbiYuPHb39jJh/DwBpxozGcl8A96B1SOgqvsAXgrscyx0VoDPBbQBfM5zr/05oGXnCPwAf80Is1BVaVeVzr4ALxYU8AzU3ATGlrW67VtwH1SIm63tfhXbvaXpgk6BBRDLUJkKW+1mMo3uhV2XYYbpaSrVro9zAL4zdm8pfS1LicpoeZeWWF5sy9Qcl0PzlNu1qMGb74OGY+Mw42jB762OZqC+I9B6WTPHjM3aM22dzEXFD+tmdN59VmmtpnkUV1+oIdCIQ9XmHdVb1/98j/1mfvXljf5I1/Do9IXSfzIUMRaXt5t7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/Slice 18@2x(1).png
// module id = LsaP
// module chunks = 2